// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hoGu3sMyk8AoIcfLoRPn {
  color: var(--grey-color-70);
}`, "",{"version":3,"sources":["webpack://./src/components/Cohort/cohort.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF","sourcesContent":[".dialogBodyWarning {\n  color: var(--grey-color-70);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogBodyWarning": `hoGu3sMyk8AoIcfLoRPn`
};
export default ___CSS_LOADER_EXPORT___;
